import React from "react";
import { cn } from "@/lib/utils";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  size?: "default" | "wide";
}

const Container: React.FunctionComponent<ContainerProps> = ({
  children,
  className,
  size = "default",
}) => {
  return (
    <div className={cn("w-full px-8 xl:px-16", size === "wide" ? "max-w-screen-2xl" : "max-w-6xl", className)}>
      {children}
    </div>
  );
};

export default Container;
